import state from './customerState'
import mutations from './customerMutations'
import actions from './customerActions'
import getters from './customerGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
